"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IntegrationsController", {
    enumerable: true,
    get: function() {
        return IntegrationsController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _integrationsservice = require("src/services/integrations.service");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _models = require("~/models");
const _responseHelpers = require("~/helpers/responseHelpers");
const _ncError = require("~/helpers/ncError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let IntegrationsController = class IntegrationsController {
    async integrationGet(context, integrationId, includeConfig, includeSources, req) {
        const integration = await this.integrationsService.integrationGetWithConfig(context, {
            integrationId,
            includeSources: includeSources === 'true'
        });
        // hide config if not the owner or if not requested
        if (includeConfig !== 'true' || integration.is_private && req.user.id !== integration.created_by) integration.config = undefined;
        if (integration.type === _nocodbsdk.IntegrationsType.Database) {
            (0, _responseHelpers.maskKnexConfig)(integration);
        }
        return integration;
    }
    async integrationCreate(context, integration, req) {
        return await this.integrationsService.integrationCreate(context, {
            integration,
            req
        });
    }
    async integrationDelete(context, integrationId, req, force) {
        return await this.integrationsService.integrationDelete(context, {
            req,
            integrationId,
            force: force === 'true'
        });
    }
    async integrationUpdate(context, integrationId, body, req) {
        const integration = await this.integrationsService.integrationUpdate(context, {
            integration: body,
            integrationId,
            req
        });
        return integration;
    }
    async integrationList(req, type, includeDatabaseInfo, limit, offset, query) {
        const integrations = await this.integrationsService.integrationList({
            req,
            includeDatabaseInfo: includeDatabaseInfo === 'true',
            type,
            query
        });
        if (!includeDatabaseInfo) {
            for (const integration of integrations.list){
                integration.config = undefined;
            }
        }
        return integrations;
    }
    async availableIntegrations() {
        return _models.Integration.availableIntegrations.sort((a, b)=>a.type.localeCompare(b.type)).sort((a, b)=>a.sub_type.localeCompare(b.sub_type)).map((i)=>({
                type: i.type,
                sub_type: i.sub_type,
                manifest: i.manifest
            }));
    }
    async getIntegrationMeta(type, subType) {
        const integration = _models.Integration.availableIntegrations.find((i)=>i.type === type && i.sub_type === subType);
        if (!integration) {
            _ncError.NcError.get({
                api_version: _nocodbsdk.NcApiVersion.V2
            }).integrationNotFound(`${type}:${subType}`);
        }
        return {
            integrationType: integration.type,
            integrationSubType: integration.sub_type,
            form: integration.form,
            manifest: integration.manifest
        };
    }
    async storeIntegration(context, integrationId, payload) {
        const integration = await _models.Integration.get(context, integrationId);
        if (!integration) {
            _ncError.NcError.get(context).integrationNotFound(integrationId);
        }
        return await this.integrationsService.integrationStore(context, integration, payload);
    }
    async integrationEndpointGet(context, integrationId, endpoint, body) {
        return await this.integrationsService.callIntegrationEndpoint(context, {
            integrationId,
            endpoint,
            payload: body
        });
    }
    constructor(integrationsService){
        this.integrationsService = integrationsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/meta/integrations/:integrationId'
    ]),
    (0, _extractidsmiddleware.Acl)('integrationGet', {
        scope: 'org'
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('integrationId')),
    _ts_param(2, (0, _common.Query)('includeConfig')),
    _ts_param(3, (0, _common.Query)('includeSources')),
    _ts_param(4, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "integrationGet", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/meta/integrations'
    ]),
    (0, _extractidsmiddleware.Acl)('integrationCreate', {
        scope: 'org'
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _nocodbsdk.IntegrationReqType === "undefined" ? Object : _nocodbsdk.IntegrationReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "integrationCreate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v2/meta/integrations/:integrationId'
    ]),
    (0, _extractidsmiddleware.Acl)('integrationDelete', {
        scope: 'org'
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('integrationId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Query)('force')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "integrationDelete", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v2/meta/integrations/:integrationId'
    ]),
    (0, _extractidsmiddleware.Acl)('integrationUpdate', {
        scope: 'org'
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('integrationId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.IntegrationReqType === "undefined" ? Object : _nocodbsdk.IntegrationReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "integrationUpdate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/meta/integrations'
    ]),
    (0, _extractidsmiddleware.Acl)('integrationList', {
        scope: 'org',
        extendedScope: 'base'
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Query)('type')),
    _ts_param(2, (0, _common.Query)('includeDatabaseInfo')),
    _ts_param(3, (0, _common.Query)('limit')),
    _ts_param(4, (0, _common.Query)('offset')),
    _ts_param(5, (0, _common.Query)('query')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.IntegrationsType === "undefined" ? Object : _nocodbsdk.IntegrationsType,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "integrationList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/integrations'
    ]),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "availableIntegrations", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/integrations/:type/:subType'
    ]),
    _ts_param(0, (0, _common.Param)('type')),
    _ts_param(1, (0, _common.Param)('subType')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.IntegrationsType === "undefined" ? Object : _nocodbsdk.IntegrationsType,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "getIntegrationMeta", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/integrations/:integrationId/store'
    ]),
    (0, _extractidsmiddleware.Acl)('integrationStore', {
        scope: 'org'
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('integrationId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "storeIntegration", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/integrations/:integrationId/:endpoint'
    ]),
    (0, _extractidsmiddleware.Acl)('integrationEndpointGet', {
        scope: 'org'
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('integrationId')),
    _ts_param(2, (0, _common.Param)('endpoint')),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], IntegrationsController.prototype, "integrationEndpointGet", null);
IntegrationsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _integrationsservice.IntegrationsService === "undefined" ? Object : _integrationsservice.IntegrationsService
    ])
], IntegrationsController);
